import ComingSoon from "../components/Comingsoon"
import { Footer } from "../components/layout/Footer"
import Navbar from "../components/layout/Navbar"


export  const JelloPages =()=>{
    return<>
    <Navbar />
    <ComingSoon />
    <Footer />
    </>
}